import { render, staticRenderFns } from "./UserProfileView.vue?vue&type=template&id=6868262c&"
import script from "./UserProfileView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserProfileView.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports